export default "__VITE_ASSET__Be06C7wb__"